module.exports = __webpack_public_path__ + "img/Neue Pramien.04567ba0.jpg";